export const empresasIntegras_item = [
    {
        "nombre": "¿QUÉ ES LA POLÍTICA DE INTEGRIDAD?",
        "icono":"DatosContactoUnidad.png",
        "formatos": [
            {
                // "nombre": "Las personas físicas y morales interesadas.",
                // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                // "html": "./Transparencia/htm/a69_f13_SC.htm"
            }
        ],
             "url" : "/interes/POLITICA%20DELA%20INTEGRIDAD%20(1)%20(2).pdf"
    },
        {
        "nombre": "Infografías Empresas Íntegras Prevenir Corrupción",
        "icono":"DatosContactoUnidad.png",
        "formatos": [
            {
                // "nombre": "Las personas físicas y morales interesadas.",
                // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                // "html": "./Transparencia/htm/a69_f13_SC.htm"
            }
        ],
         "url" : "/interes/Infografias_Empresas_Integras_Prevenir_Corrupción.pdf"
        },
		{
			"nombre": "Infografías Empresas Integras que es la Política de Integridad",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			 "url" : "/interes/Infografias Empresas Integras QUE ES LA POLITICA DE INTEGRIDAD.pdf"
			},
		{
			"nombre": "Cartel Padrón Empresas Íntegras",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			 "url" : "/interes/Cartel Padron Empresas Integras.pdf"
			},
			{
				"nombre": "Registro en el Padrón de Proveedores y Contratistas",
				"icono":"DatosContactoUnidad.png",
				"formatos": [
					{
						// "nombre": "Las personas físicas y morales interesadas.",
						// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
						// "html": "./Transparencia/htm/a69_f13_SC.htm"
					}
				],
				 "url" : "/interes/Triptico_Padron_Nuevo_Impresión.pdf"
				},
				{
					"nombre": " Padrón de Empresas Íntegras ",
					"icono":"DatosContactoUnidad.png",
					"formatos": [
						{
							// "nombre": "Las personas físicas y morales interesadas.",
							// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
							// "html": "./Transparencia/htm/a69_f13_SC.htm"
						}
					],
					 "url" : "/interes/RELACION_EMPRESAS_INTEGRAS_19DIC2024.pdf"
				},
				
			
	

];